
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1024 1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M511.503 14.221C236.73 14.221 14.222 237.226 14.222 512s222.508 497.777 497.281 497.777c275.27 0 498.274-223.004 498.274-497.777S786.773 14.221 511.503 14.221zm.497 896c-220.017 0-398.223-178.204-398.223-398.221 0-220.019 178.205-398.223 398.223-398.223S910.223 291.981 910.223 512c0 220.017-178.206 398.221-398.223 398.221zM501.05 263.11h-2.987c-19.913 0-35.84 15.93-35.84 35.84V533.9c0 17.423 8.96 33.85 24.39 42.81L693.19 700.657c16.926 9.956 38.827 4.977 48.783-11.947 10.453-16.924 4.977-39.324-12.444-49.28l-192.64-114.49V298.95c0-19.91-15.93-35.84-35.84-35.84z"}})])
          )
        }
      }
    